import { addClassName } from '@hc-frontend/core-utils-format';
import { forwardRef } from 'react';

import type { ButtonProps } from './button.types';

const styles: Record<
  ButtonProps['variant'],
  React.HTMLAttributes<'button'>['className']
> = {
  primary: 'hc-btn--primary',
  'primary-card': 'hc-btn--primary-card',
  'primary-card-small': 'hc-btn--primary-card-small',
  secondary: 'hc-btn--secondary-card',
  'secondary-dark': 'hc-btn--secondary-card-dark',
  tertiary: 'hc-btn--tertiary-card-solid',
  'tertiary-dark': 'hc-btn--tertiary-card-dark',
  text: 'hc-btn--text',
};

export const Button = forwardRef<
  HTMLButtonElement,
  JSX.IntrinsicElements['button'] & ButtonProps
>(({ variant, icon, children, className, type, ...props }, ref) => (
  <button
    ref={ref}
    {...props}
    // eslint-disable-next-line react/button-has-type
    type={type}
    className={addClassName(
      variant === 'text' ? 'hc-icon-layout--left' : 'hc-icon-layout--right',
      styles[variant],
      className,
    )}
  >
    {variant === 'text' && icon}
    {children}
    {variant !== 'text' && icon}
  </button>
));

export default Button;
